import styled from "@emotion/styled";

import { setFullViewportWidthStyles } from "shared/lib/styles";

export const PageContainer = styled.div`
  ${setFullViewportWidthStyles()}
`;

export const PageWrapper = styled.div`
  inline-size: 100%;
  max-inline-size: 2056px;
  margin-block: 0;
  margin-inline: auto;
`;
